<template>
  <div :class="className" :style="{height:height,width:width}" />
</template>

<script>
import echarts from 'echarts'
// require('echarts/theme/macarons') // echarts theme
import resize from './resize'
import { getDateAndHour, updateTime, howLongAgo, getDateAndWeek } from '@/utils/updateTime.js'
import store from '@/store'
import { temChange, temUnit } from '@/utils/temChange.js'
export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    },
    lineChartData: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      chart: null
    }
  },
  watch: {
    lineChartData: {
      handler(newValue, oldValue) {
        this.lineChartData = newValue // 把新值赋值给我们的属性数据
        this.initChart() // 刷新echarts图表
      },
      deep: true
    }
  },
  mounted() {
    this.$nextTick(() => {
    })
    setTimeout(() => {
      this.initChart()
    }, 500)
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
    // 组件销毁前移除监听
    window.removeEventListener('resize', this.resizePerformanceFun)
  },
  methods: {
    initChart() {
      if (this.chart) {
        this.chart.clear()
      }
      var sn = this.lineChartData.sn
      this.chart = echarts.init(this.$el)
      var temType = store.state.temType || 'ssd'
      var tem = 'Temp.(℃)'
      var temS = 'C'
      if (temType != 'ssd') { // 华氏度
        tem = 'Temp.(℉)'
        temS = 'F'
      } else {
        tem = 'Temp.(℃)'
        temS = 'C'
      }
      var option = {
        title: {
          text: ''
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          },
          formatter: function(params, ticket, callback) {
            var htmlStr = ''
            var timeP = '<p>' + params[0] ? getDateAndHour(params[0].axisValue) : '' + '</p>'
            for (var j = 0; j < params.length; j++) {
              var param = params[j]
              var seriesName = param ? param.seriesName : ''// 图例名称
              var color = param ? param.color : ''// 图例颜色
              var value = param ? param.data[1] : ''

              htmlStr += '<div>'
              // 圆点
              htmlStr += '<span style="margin-right:5px;display:inline-block;width:10px;height:10px;border-radius:5px;background-color:' + color + ';"></span>'
              if (param) {
                // 圆点后面显示的文本
                htmlStr += seriesName + '：' + value
              }
              htmlStr += '</div>'
            }
            var result = '<p>' + sn + '</p>' + timeP + htmlStr
            return result
          }
        },
        // legend: {
        //   data: ['Cha.(A)', 'Dis.(A)', 'Volt(V)', 'Cha.(Ah)', 'Dis.(Ah)', 'SOC(%)', 'Temp.(℃)', 'Ignit(V)', 'HourMeter(V)', 'Aux.Volt(V)', 'Aux.Cha(A)', 'Aux.Dis(A)', 'Aux.Soc(%)'],
        //   selected: {// 默认不展示
        //     'Cha.(Ah)': false,
        //     'Dis.(Ah)': false,
        //     'SOC(%)': false,
        //     'Temp.(℃)': false,
        //     'Ignit(V)': false,
        //     'HourMeter(V)': false,
        //     'Aux.Volt(V)': false,
        //     'Aux.Cha(A)': false,
        //     'Aux.Dis(A)': false,
        //     'Aux.Soc(%)': false
        //   }
        // },
        legend: [{
          // icon: 'rect',
          itemWidth: 12,
          itemHeight: 12,
          data: ['Cha.(A)', 'Dis.(A)', 'Volt(V)', 'Cha.(Ah)', 'Dis.(Ah)', 'SOC(%)', tem, 'Cha.(kWh)', 'Dis.(kWh)'],
          selected: {// 默认不展示
            'Cha.(Ah)': false,
            'Dis.(Ah)': false,
            'SOC(%)': false,
            tem: false,
            'Cha.(kWh)': false,
            'Dis.(kWh)': false
          }
        }],
        grid: {
          // left: '3%',
          // right: '4%',
          // bottom: '3%',
          // // top: '15%',
          // containLabel: true
        },

        xAxis: {
          type: 'time',
          showAllSymbol: true,
          splitLine: {
            show: false
          },
          axisLabel: {
            formatter: function(value, index) {
              return new Date(value).toLocaleDateString()
            }
          },
          zlevel: 1

        },
        yAxis: [
          {
            axisLine: {
              lineStyle: {
                color: '#323232'
              }
            },
            type: 'value',
            name: 'A',
            position: 'left',
            offset: 0,
            boundaryGap: [0, '100%'],
            splitLine: {
              show: false
            }
          },
          {
            axisLine: {
              lineStyle: {
                color: '#0B438B'
              }
            },
            splitLine: {
              show: false
            },
            type: 'value',
            name: 'V',
            position: 'right',
            axisTick: {
              inside: 'false'
            }
          },
          {
            axisLine: {
              lineStyle: {
                color: '#2B2B2B'
              }
            },
            offset: 40,
            splitLine: {
              show: false
            },
            scale: true,
            type: 'value',
            name: 'Ah',
            position: 'left'

          },
          {
            axisLine: {
              lineStyle: {
                color: '#90C552'
              }
            },
            splitLine: {
              show: false
            },

            offset: 40,
            type: 'value',
            name: '%',
            position: 'right',
            boundaryGap: [0, '100%'],
            axisTick: {
              inside: 'false',
              length: 10
            }
          },
          {
            axisLine: {
              lineStyle: {
                color: '#324CD2'
              }
            },
            splitLine: {
              show: false
            },
            offset: 80,
            type: 'value',
            name: temUnit(),
            position: 'right',
            boundaryGap: [0, '100%'],
            axisTick: {
              inside: 'false',
              length: 10
            }
          },
          {
            axisLine: {
              lineStyle: {
                color: '#FFCC00'
              }
            },

            splitLine: {
              show: false
            }

          }
        ],

        dataZoom: [{
          show: true,
          realtime: true,
          start: 0,
          end: 100,
          textStyle: {
            color: '#A5D239'
          }
        }, {
          type: 'inside',
          realtime: true,
          start: 0,
          end: 100
        }],

        color: ['#87cefa', '#ffabac', '#8e038b', '#0e8dcd', '#ed4b0d', '#298E09', '#324CD2', '#FFCC00', '#996666', '#cc6699', '#339999', '#9966cc', '#6699cc', '#ff9933', '#cc6666', '#666699'], // 在这里设置colorList，是一个数组，图片颜色会按顺序选取
        series: [
          {
            name: 'Cha.(A)',
            type: 'line',
            data: this.lineChartData.d3,
            symbol: 'none',
            tooltip: {
              trigger: 'axis'
            },
            // smooth: true,
            yAxisIndex: 0
          },
          {
            name: 'Dis.(A)',
            type: 'line',
            data: this.lineChartData.d4,
            symbol: 'none',
            tooltip: {
              trigger: 'axis'
            },
            // smooth: true,
            yAxisIndex: 0,
            itemStyle: { normal: { label: { show: true, position: 'left' }}}
          },

          {
            name: 'Volt(V)',
            type: 'line',
            symbol: 'none',
            showAllSymbol: true,
            data: this.lineChartData.d5,
            tooltip: {
              trigger: 'axis'
            },
            // smooth: true,
            yAxisIndex: 1,
            itemStyle: { normal: { label: { show: true, position: 'left' }}}
          },
          {
            name: 'Cha.(Ah)',
            type: 'line',
            symbol: 'none',
            tooltip: {
              trigger: 'axis'
            },

            data: this.lineChartData.d6,
            yAxisIndex: 2
          },
          {
            name: 'Dis.(Ah)',
            type: 'line',
            symbol: 'none',
            data: this.lineChartData.d7,
            tooltip: {
              trigger: 'axis'
            },
            yAxisIndex: 2
          },
          {
            name: 'SOC(%)',
            type: 'line',
            tooltip: {
              trigger: 'axis'
            },
            symbol: 'none',
            data: this.lineChartData.d8,
            yAxisIndex: 3
          },
          {
            name: tem,
            type: 'line',
            tooltip: {
              trigger: 'axis'
            },
            symbol: 'none',
            data: this.lineChartData.d9,
            yAxisIndex: 4
          },
          {
            name: 'Cha.(kWh)',
            type: 'line',
            symbol: 'none',
            tooltip: {
              trigger: 'axis'
            },

            data: this.lineChartData.d10,
            yAxisIndex: 2
          },
          {
            name: 'Dis.(kWh)',
            type: 'line',
            symbol: 'none',
            data: this.lineChartData.d11,
            tooltip: {
              trigger: 'axis'
            },
            yAxisIndex: 2
          }
        ]
      }
      this.chart.setOption(option, true)
      //  监听窗口大小改变图表大小（先移除再监听，防止出错）
      window.removeEventListener('resize', this.resizePerformanceFun)
      window.addEventListener('resize', this.resizePerformanceFun)
    },
    resizePerformanceFun() {
      if (this.chart) {
        // console.log('窗口改变了，重新渲染图形')
        this.chart.resize()
      }
    }
  }
}
</script>
